import React from "react";
import AppBar from "../../components/OftadehAppBar/AppBar";

const Header = () => <AppBar drawerWidth={240} />;

export default Header;
